import { render, staticRenderFns } from "./DvlsIcon.vue?vue&type=template&id=333dd6c3"
import script from "./DvlsIcon.vue?vue&type=script&lang=js"
export * from "./DvlsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports